import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../components/Hello.vue"),
    meta: { title: "首页" }
  }, //首页
  {
    path: "/Productcenter",
    component: () => import("../components/page/Productcenter.vue"),
    meta: { title: "产品中心" }
  },
  {
    path: "/Productcase",
    component: () => import("../components/page/Productcase.vue"),
    meta: { title: "成功案例" }
  },
  {
    path: "/Aboutus",
    component: () => import("../components/page/Aboutus.vue"),
    meta: { title: "关于我们" }
  },
  {
    path: "/wisdom",
    component: () => import("../components/page/wisdom.vue"),
    meta: { title: "智慧管理" }
  },
  {
    path: "/information",
    component: () => import("../components/page/information.vue"),
    meta: { title: "生活信息平台" }
  },
  {
    path: "/Paycost",
    component: () => import("../components/page/Paycost.vue"),
    meta: { title: "缴费管理功能" }
  },
  {
    path: "/Entranceguard",
    component: () => import("../components/page/Entranceguard.vue"),
    meta: { title: "门禁功能" }
  },
  {
    path: "/Thebrake",
    component: () => import("../components/page/Thebrake.vue"),
    meta: { title: "道闸系统" }
  },
  {
    path: "/Intelligentlife",
    component: () => import("../components/page/Intelligentlife.vue"),
    meta: { title: "智慧生活商圈" }
  },
  {
    path: "/Therepair",
    component: () => import("../components/page/Therepair.vue"),
    meta: { title: "物业报修管理" }
  },
  {
    path: "/Theuserinformation",
    component: () => import("../components/page/Theuserinformation.vue"),
    meta: { title: "用户信息功能" }
  },
  {
    path: "/financial",
    component: () => import("../components/page/financial.vue"),
    meta: { title: "财务数据统计" }
  },
  {
    path: "/Propertynotice",
    component: () => import("../components/page/Propertynotice.vue"),
    meta: { title: "物业通知功能" }
  },
  {
    path: "/Waterelectricity",
    component: () => import("../components/page/Waterelectricity.vue"),
    meta: { title: "水电暖气管理" }
  },
  {
    path: "/defense",
    component: () => import("../components/page/defense.vue"),
    meta: { title: "智慧安防" }
  },
  {
    path: "/control",
    component: () => import("../components/page/control.vue"),
    meta: { title: "智慧监管" }
  },
  {
    path: "/news",
    component: () => import("../components/page/news.vue"),
    meta: { title: "新闻资讯" }
  },
];

export default new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js